import { getList, getListExtended } from '../../../api/list'
import { getTree } from '../../../api/tree'
import {
  ORGANIZATION_SELECTOR_ROOT_PAGE_SIZE,
  SELECTOR_NODE_PAGE_SIZE,
  SELECTOR_SEARCH_PAGE_SIZE,
} from '../../../constants/pagination'
import { getCurrentOrganizationId } from '../../../state/organizationContextOptions'

export function fetchRootOrganizations(orgId = null) {
  return getList('ORGANIZATION', 0, '', ORGANIZATION_SELECTOR_ROOT_PAGE_SIZE, orgId ?? getCurrentOrganizationId(), false)
}

export function fetchChildOrganizations(orgId) {
  return getTree(orgId)
}

export function fetchParticipants({filter, orgId, recursive, filterValue = ''}) {
  const pageSize = recursive ? SELECTOR_SEARCH_PAGE_SIZE : SELECTOR_NODE_PAGE_SIZE

  return getListExtended(
    {participantMultiFilter: filter},
    'PARTICIPANT',
    0,
    filterValue,
    pageSize,
    orgId,
    recursive
  )
}

export function fetchParticipantGroups({groupname, orgId, recursive}) {
  const pageSize = recursive ? SELECTOR_SEARCH_PAGE_SIZE : SELECTOR_NODE_PAGE_SIZE

  return getList('PARTICIPANT_GROUP', 0, groupname, pageSize, orgId, recursive)
}
